import * as LocationsClient from '../clients/locations';
import { constants } from '../stores/LocationsStore';

export default {
  locations: {
    fetchCountries() {
      this.dispatch(constants.FETCH_COUNTRIES);

      LocationsClient.fetchCountries()
        .then(countries => this.dispatch(constants.FETCH_COUNTRIES_SUCCESS, countries));
    },
    fetchApprovedLocations() {
      LocationsClient.fetchApprovedLocations()
        .then(locations => {
          this.dispatch(constants.FETCH_APPROVED_LOCATIONS_SUCCESS, locations);
        });
    },
    fetchTopDestinations() {
      LocationsClient.fetchTopDestinations()
        .then((result) => {
          const locationAreas = result.relations.filter(relation => relation._type === 'location_area');
          const locationAreasJoined = locationAreas.map((locationArea) => {
            return {
              ...locationArea,
              ...(result.data.filter(data => data.id === locationArea._id)[0]),
            };
          });

          this.dispatch(
            constants.FETCH_TOP_DESTINATIONS,
            locationAreasJoined,
          );
        });
    },
  },
};
